<template>
  <router-view></router-view>
  <BaseLoading />
  <ModalConfirmApi />
  <ModalAlert />
  <Aggregation />
  <NewMailsCreate />
  <TabListMailDelete />
</template>

<script>
import BaseLoading from "/src/components/utilitys/BaseLoading.vue";
import ModalConfirmApi from "/src/components/modals/ModalConfirmApi.vue";
import ModalAlert from "/src/components/modals/ModalAlert.vue";
import Aggregation from "/src/components/aggregation/Aggregation.vue";
import NewMailsCreate from "/src/components/new-mails/sending-plan/NewMailsCreate.vue";
import TabListMailDelete from "/src/components/new-mails/main/TabListMailDelete.vue";

export default {
  name: "App",
  components: {
    BaseLoading,
    ModalConfirmApi,
    ModalAlert,
    Aggregation,
    NewMailsCreate,
    TabListMailDelete,
  },
};
</script>
